<template>
  <div
    @click="handleClick"
    class="flex items-center justify-between w-full cursor-pointer select-none"
  >
    <h6
      class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold tracking-wider block no-underline"
    >
      {{ title }}
    </h6>
  </div>
  <div
    class="overflow-hidden ease-in-out transition-all duration-150"
    :style="isOpen ? `height:${this.options.length * 44}px` : 'height:0px'"
  >
    <ul>
      <li
        class="pt-6 text-gray-400 text-xs uppercase font-medium block truncate"
        v-for="(value, index) in options"
        :key="index"
      >
        <router-link
          v-if="value.be_used !== '0'"
          :to="value.url || `/component/${value.id}`"
          v-slot="{ href, navigate, isActive }"
        >
          <a
            :href="href"
            @click="navigate"
            class="text-xs uppercase font-medium block truncate"
            :class="[
              isActive
                ? 'text-[#6b6ca9] hover:text-[#6b6ca9]'
                : 'text-blueGray-400 hover:text-blueGray-500'
            ]"
          >
            <i
              :class="
                isActive
                  ? 'opacity-75' + ` ${value.icon} mr-1 text-sm`
                  : 'text-blueGray-300' + ` ${value.icon} mr-1 text-sm`
              "
            ></i>
            {{ value.name }}</a
          >
        </router-link>
        <div
          v-else
          class="text-xs uppercase font-medium block truncate cursor-not-allowed text-amber-500 hover:text-amber-600"
        >
          <i :class="'text-amber-500 fas fa-ban mr-1 text-sm'"></i>
          {{ value.name }}
        </div>
      </li>
    </ul>
  </div>
  <hr class="my-4 md:min-w-full" />
</template>

<script>
export default {
  name: "SideBarDropDown",
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
